import React from 'react';
import { Container, Header, Segment, Accordion, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import './styles.css';

function FAQ() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = React.useState(-1);

  const faqData = [
    { key: 'dresscode', question: t('faq.dresscode.question'), answer: t('faq.dresscode.answer') },
    { key: 'time', question: t('faq.time.question'), answer: t('faq.time.answer') },
    { key: 'parking', question: t('faq.parking.question'), answer: t('faq.parking.answer') },
    { key: 'kids', question: t('faq.kids.question'), answer: t('faq.kids.answer') },
    { key: 'gifts', question: t('faq.gifts.question'), answer: t('faq.gifts.answer') },
    { key: 'photos', question: t('faq.photos.question'), answer: t('faq.photos.answer') },
    { key: 'menu', question: t('faq.menu.question'), answer: t('faq.menu.answer') },
    { key: 'hotel', question: t('faq.hotel.question'), answer: t('faq.hotel.answer') },
  ];

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  return (
    <div>
      <div className="faq-wrapper">
        <Segment className="faq-segment" vertical>
          <Container className="faq-container">
            <Header as='h1' textAlign='center' className="faq-title">
              {t('faq.title')}
            </Header>
            <p className="faq-subtitle">
              {t('faq.subtitle')}
            </p>

            <Segment>
              <Accordion fluid styled>
                {faqData.map((faq, index) => (
                  <React.Fragment key={faq.key}>
                    <Accordion.Title
                      active={activeIndex === index}
                      index={index}
                      onClick={handleClick}
                    >
                      <Icon name='dropdown' />
                      {faq.question}
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === index}>
                      <p>{faq.answer}</p>
                    </Accordion.Content>
                  </React.Fragment>
                ))}
              </Accordion>
            </Segment>

            <Segment textAlign='center' className="faq-contact-section">
              <Header as='h3'>{t('faq.moreQuestions')}</Header>
              <p className="faq-contact-text">
                {t('faq.contactUs')}
              </p>
            </Segment>
          </Container>
        </Segment>
      </div>
    </div>
  );
}

export default FAQ;
